import IBModuleApi from "../../api/rolecatalogAPI";
import { urlContexts } from "../../constants";

export const getBaseRolesByTenant = async (tenantId: string, roleTypeId: string) => {
  const { data } = await IBModuleApi.get(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/user-role/assigned-me?tenantId=${tenantId}${!!roleTypeId ? ('&roleTypeId=' + roleTypeId) : ''}`
  );

  return data;
};

export const createUserRole = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/user-role`,
    createInfo
  );

  return data;
};

export const getUserRoleByUser = async (userId: any) => {
  const { data } = await IBModuleApi.get(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/user-role?userId=${userId}`
  );

  return data;
};